<template>
	<popup class="select_image_popup" noscroll title="Select an image" @close="closeThisPopup">
		<template v-slot:content>
			<Loading v-if="loading"/>
				<div class="__cats_container">
					<v-button @click="newFolderState = !newFolderState" slim border class="add-folder-btn" label="Add new folder" />
					<div class="__create_folder_box" v-if="newFolderState">
						<input-field small placeholder="New folder name..." v-model="newFolderInput" />
						<div class="__btns">
							<v-button class="flex-none" @click="newFolderState = false" slim border label="Cancel" />
							<v-button class="flex" :loading="creatingFolder" @click="createNewFolder" slim label="Create folder" />
						</div>
					</div>
					<ul class="__cats scroll">
						<li class="__cat-item"
						    v-for="(item, index) in popupCategories"
						    :class="{'active' : item.id == popupActiveCategory}"
						    @click="popupActiveCategory = item.id">
							<span class="flex">{{item.name}}</span>
							<a class="__del-btn" v-if="item.id !== 0" @click.stop="folderToDelete=item.id;deleteFolderPopup=true;">
								<inline-svg :src="require('@/assets/img/delete_icon.svg')" />
							</a>
						</li>
					</ul>
				</div>
				<div class="__upload_container">
					<form class="popup_right_header upload-image" enctype="multipart/form-data">
						<v-button class="upload-btn" :loading="uploading"
						          label="Upload new image" slim :icon="require('@/assets/img/upload.svg')" />
						<input  type="file" @change="uploadFile" accept="image/*" class="input-file" name="image"/>
					</form>
					<div class="imgs-wrapper" v-if="imageFilteredList.length">
						<div class="select_img_items_list">
							<div v-for="(item, index) in imageFilteredList" class="select_img_item" @click="chooseImage(item)">
								<a class="xs_delete_btn" @click.stop="showDeletePopup(item.id)" v-tippy="{theme:'small-black'}"
								   content="Delete image">
									<svg fill="none" viewBox="0 0 10 10" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
										<path xmlns="http://www.w3.org/2000/svg" d="M8.43749 1.25H6.5625V0.625002C6.5625 0.279689 6.2828 0 5.93749 0H4.0625C3.71718 0 3.43749 0.279689 3.43749 0.625002V1.25H1.5625C1.21719 1.25 0.9375 1.52969 0.9375 1.87501V2.50001C0.9375 2.845 1.21719 3.12469 1.56188 3.12501H8.43783C8.78282 3.12469 9.06252 2.845 9.06252 2.50001V1.87499C9.0625 1.52969 8.78281 1.25 8.43749 1.25ZM5.93749 1.25H4.0625V0.937496C4.0625 0.764999 4.20249 0.624988 4.37499 0.624988H5.62499C5.79749 0.624988 5.93749 0.764985 5.93749 0.937496V1.25ZM1.56249 8.75001C1.56249 9.44032 2.12217 10 2.81249 10H7.1875C7.87781 10 8.43749 9.44032 8.43749 8.75001V3.75H1.56249V8.75001ZM6.25001 4.68751C6.25001 4.51501 6.39001 4.375 6.5625 4.375C6.735 4.375 6.875 4.515 6.875 4.68751V8.4375C6.875 8.61 6.735 8.75001 6.5625 8.75001C6.39001 8.75001 6.25001 8.61 6.25001 8.4375V4.68751ZM4.6875 4.68751C4.6875 4.51501 4.82749 4.375 5 4.375C5.17252 4.375 5.3125 4.515 5.3125 4.68751V8.4375C5.3125 8.61 5.1725 8.75001 5 8.75001C4.82751 8.75001 4.6875 8.61 4.6875 8.4375V4.68751ZM3.12499 4.68751C3.12499 4.51501 3.26498 4.375 3.43749 4.375C3.61 4.375 3.75 4.515 3.75 4.68751V8.4375C3.75 8.61 3.61 8.75001 3.43749 8.75001C3.26498 8.75001 3.12499 8.61 3.12499 8.4375V4.68751Z" fill="#FB595B"></path>
									</svg>
								</a>
								<div class="img_wrpr">
									<img :src="`//img.funnelish.com/${item.path}?auto=webp&fit=bounds&width=160&height=160`">
								</div>
								<p v-tippy="{theme:'small-black'}" :content="item.name">{{item.name}}</p>
							</div>
						</div>
					</div>
					<div class="not_yet_box" v-else>
						There are no images in this folder yet
					</div>
				</div>

			<div class="popup_wrpr active" v-if="deletePopup">
				<div class="popup_wrpr_inner">
					<div class="__delete-popup popup">
						<div class="popup_header">
							<h3>Are you sure you'd like to delete this image?</h3>
							<a @click="deletePopup = false" class="close_popup_btn">
								<svg fill="none" viewBox="0 0 14 14" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M7.14216 5.82149L12.4455 0.518184L13.624 1.6967L8.32067 7L13.624 12.3033L12.4455 13.4818L7.14216 8.17851L1.83886 13.4818L0.660354 12.3033L5.96365 7L0.660354 1.6967L1.83886 0.518184L7.14216 5.82149Z" fill="#C5C7D2"></path></svg>
							</a>
						</div>
						<div class="popup_btn_wrpr mt_0 active">
							<v-button slim @click="deleteImage(deleteImageId)" :loading="deletingImage" red border label="Delete"></v-button>
							<v-button slim @click="deletePopup = false" label="Cancel" />
						</div>
					</div>
				</div>
			</div>

			<div class="popup_wrpr active" v-if="deleteFolderPopup">
				<div class="popup_wrpr_inner">
					<div class="__delete-popup popup">
						<div class="popup_header">
							<h3>Are you sure you'd like to delete this folder?</h3>
							<a @click="deleteFolderPopup = false" class="close_popup_btn">
								<inline-svg :src="require('@/assets/img/close_popup.svg')" />
							</a>
						</div>
						<div class="popup_btn_wrpr mt_0 active">
							<v-button slim @click="deleteCategory()" :loading="deletingFolder" red border label="Delete"></v-button>
							<v-button slim @click="deleteFolderPopup = false" label="Cancel" />
						</div>
					</div>
				</div>
			</div>

		</template>
	</popup>
</template>

<script>
import API from "@/api"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import InputField from "@/components/base/input-field";
export default {
    name: 'SelectImagePopup',
    components: {
	    InputField,
	    Popup,
        Loading,
        VButton,
    },
    mixins: [API],
	props:['funnelId'],
    data: function(){
        return {
	        deletingImage:false,
	        deletingFolder:false,
					creatingFolder:false,
            // funnelId: null,
            newFolderState: false,
            popupActiveCategory: 0,
            popupCategories: [
                { id: 0, name: 'All Images' },
            ],
            selectImageItems: [],
            newFolderInput: '',
            loading: true,
	        uploading:false,
	        deletePopup: false,
	        deleteFolderPopup: false,
          deleteImageId: 0,
	        folderToDelete:null,
        }
    },
    computed: {
        imageFilteredList() {
					if (!this.selectImageItems) return [];
            let lst = this.selectImageItems.filter(item => {
                if(this.popupActiveCategory === 0) {
                    return this.selectImageItems
                } else {
                    return item.folder_id === this.popupActiveCategory
                }
            })
	        lst = lst.sort((a,b)=>b.id - a.id)
	        return lst;
        }
    },
    methods: {
        showDeletePopup(id){
            this.deletePopup = true;
            this.deleteImageId = id;
        },
        closeThisPopup(){
	        this.$emit('closePopup');
	        this.$emit('close');
        },
        chooseImage(item){
	        this.$emit('imageChoosed', item);
	        this.$emit('done', item);
          this.closeThisPopup();
        },
        async deleteImage(id) {
					try {
						this.deletingImage = true;
						var result = await this.api.images.delete(id);

						this.selectImageItems.splice(this.selectImageItems.findIndex(item => {
							return item.id === id
						}), 1);
						this.deletePopup = false;
					} catch (e){
						this.$error(e)
					}
	        finally {
						this.deletingImage = false;
					}
        },
        async uploadFile(e) {
        	try {
		        this.uploading = true;

		        var fileList = e.target.files
		        var fieldName = e.target.name

		        const formData = new FormData();

		        if (!fileList.length) return;

		        Array
				        .from(Array(fileList.length).keys())
				        .map(x => {
					        formData.append(fieldName, fileList[x], fileList[x].name);
				        });

		        var result = await this.api.images.create(this.funnelId, formData, this.popupActiveCategory);
		        if (result.id) {
			        this.selectImageItems.push(result)
		        } else {
			        this.$error(result)
		        }
	        } catch (e) {
		        this.$error(e)
	        } finally {
		        this.uploading = false;
	        }
        },
        async createNewFolder(){
					try {
						this.creatingFolder = true;
						let newFolder = {
							funnel_id: this.funnelId, name: this.newFolderInput
						}
						let result = await this.api.images.foldersCreate(newFolder);
						if (result.id) {
							newFolder.id = result.id
							this.popupCategories.push(newFolder)
							this.newFolderInput = '';
							this.newFolderState =false;
						} else {
							this.$error(result)
						}
					} catch (e) {
						this.$error(e)
					} finally {
						this.creatingFolder = false;
					}
        },
        async deleteCategory(){
					try {
						if (!this.folderToDelete) return;
						this.deletingFolder = true;

						let res = await this.api.images.foldersDelete(this.folderToDelete);
						if (res && res.error)
							throw res;

						let index = this.popupCategories.findIndex(x=>x.id===this.folderToDelete)
						this.popupCategories.splice(index, 1);

						this.deleteFolderPopup = false;
					} catch (e) {
						this.$error(e)
					} finally {
						this.deletingFolder = false;
					}
        },
        async init() {
        	try {
		        this.loading = true;

		        let folders = await this.api.images.foldersGet();
		        let summary = this.popupCategories.concat(folders);
		        this.popupCategories = summary;

		        let images = await this.api.images.get();
		        this.selectImageItems = images;

	        } catch (e) {
		        this.$error(e)
	        } finally {
		        this.loading = false;
	        }
        }
    },
    created() {
        this.init();
    }

}
</script>
<style lang="scss">
.select_image_popup {
	.popup {
		@include default-font;
		max-height: calc(100vh - 64px);
		overflow: hidden;
		max-width: 900px;
		position: relative;

		.popup_btn_wrpr.actions {
			display: none;
		}
		> .popup_header {
			margin-bottom: 0;
		}
		> .content {
			padding: 0;
			border-radius: 5px;
			border: 1px solid $light-grey;
			margin: 5px;
			display: flex;
			flex-direction: row;
			flex: 1;
		}
	}
	.upload-btn svg path {
		fill: white;
	}
}
</style>
<style lang="scss" scoped>
.__cats {
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding-right: 12px;
}
.__cats_container {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 205px;
	padding: 10px 0 10px 8px;
	background: $light-blue;
	border-radius: 5px 0 0 5px;
	border-right: 1px solid $light-grey;
}
.__upload_container {
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: 10px;
	.not_yet_box {
		margin: auto;
		text-align: center;
	}
}
.__cat-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
	min-height: 30px;
	border-radius: 5px;
	cursor: pointer;
	padding: 3px 10px;
	&:hover {
		background: $hover-light-blue;
		.__del-btn {
			display: flex;
		}
	}
	&.active {
		background: $hover-light-blue;
		color: $blue;
	}
	.__del-btn {
		right: 5px;

		position: absolute;
		padding: 5px 3px;
		display: none;
		top: auto;
		bottom: auto;
		border-radius: 5px;
		&:hover{
			background: $dark-hover-light-blue;
		}
		svg {
			height: 14px;
		}
	}
}
.__create_folder_box {
	margin-bottom: 10px;
	border: 1px dashed $grey;
	padding: 5px;
	width: 100%;
	border-radius: 3px;
	.input-field{
		margin-bottom: 9px;
		font-size: 12px;
	}
	.__btns {
		display: flex;
		flex-direction: row;
		gap: 10px;
		.button {
			height: 26px;
			padding: 3px 6px;
			align-items: center;
			display: flex;
			flex-direction: column;
		}
	}
}
.__delete-popup {
	max-width: 500px;
}
.select_image_popup {

	.upload-image {
		position: relative;
	}
	input.input-file {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 1;
		cursor: pointer;
		opacity: 0;
	}
	.choose-btn {
		height: 28px;
	}
	.add-folder-btn {
		margin-bottom: 15px;
		padding: 3px 10px;
		height: 26px;
	}
	.create_folder_box {
		.button {
			padding: 4px 8px;
			width: auto;
			font-size: 11px;
			min-height: 0;
			height: 23px;
			margin: 0 4px;
		}
	}
	ul {
		max-height: 100%;
		flex: 1;
		width: 100%;
	}
	.cr_autom_right {
		padding: 15px;
		display: flex;
		flex-direction: column;
	}
	.popup_right_header {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 15px;
	}
	.select_img_items_list {
		margin: 0;
		height: fit-content;
		min-height: 300px;
		grid-gap: 15px;
		padding: 10px 10px 10px 0;
		//grid-template: 200px 200px;
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
	}
	.imgs-wrapper {
		display: block;
		overflow: scroll;
		height: 100%;
		width: 100%;
	}
	.select_img_item {
		display: flex;
		flex-direction: column;
		width: 100%;
		border: 1px solid #EBEFF6;
		padding: 5px;
		border-radius: 5px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		transition: 0.15s all ease-in-out;
		height: 160px;

		.xs_delete_btn {
			display: none;
			width: 26px;
			height: 26px;
			align-items: center;
			justify-content: center;
			position: absolute;
			left: 5px;
			top: 5px;
			border-radius: 5px;
			z-index: 1;
		}
		.img_wrpr {
			overflow: hidden;
			position: relative;
			display: flex;
			height: 100%;
			background: whitesmoke;
			border-radius: 4px;
			img {
				width: 100%;
				height: 100%;
				object-fit: scale-down;
			}
		} // .img_wrpr
		p {
			font-weight: normal;
			font-size: 10px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #C5C7D2;
			margin: 3px 0 0;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}
		&:hover {
			border: 1px solid $sharp-blue;
			.xs_delete_btn {
				display: flex;
				&:hover {
					background: rgba(90, 93, 97, 0.17);
				}
			}
		} // .hover_block
		&.active, &:hover {
			border: 1px solid $sharp-blue;
		}
		&.active p {
			color: #636A7B;
		}
	} // .select_img_item
	.popup_header h3 {
		font-size: 16px;
	}
} // .select_image_popup

</style>
